import React, { useMemo } from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { assetUrl } from 'utils/url'
import { useKemudahanSurveyDialog } from 'app/KinerjaShared/hooks/use-kemudahan-survey-dialog'
import { useKemudahanSurveyTrackEvent } from 'app/KinerjaShared/hooks/use-kemudahan-survey-track-event'
import { useAuth } from 'utils/auth'
import {
  type StatusPelaksanaanPraktikKinerja,
  StatusPelaksanaanPraktikKinerjaList,
} from 'types/kinerja-penilik-pegawai'

type PelaksanaanKemudahanSurveyCardProps = {
  className?: string
  praktikKinerjaStatus: StatusPelaksanaanPraktikKinerja
}

export function PelaksanaanKemudahanSurveyCard({
  className,
  praktikKinerjaStatus,
}: PelaksanaanKemudahanSurveyCardProps) {
  // -------------------------
  // Handle Kemudahan Survey
  // -------------------------
  const { session } = useAuth()
  const ptkId = session?.user?.ptkId

  const {
    isEnabled: isSurveyEnabled,
    isSubmitted: isSurveySubmitted,
    markAsSubmitted: markAsSubmittedSurvey,
  } = useKemudahanSurveyDialog({
    type: 'pelaksanaan-penilik',
    additionalKey: ptkId,
  })

  const { trackEvent: trackSurveyEvent } = useKemudahanSurveyTrackEvent()

  const handleClickSurvey = () => {
    trackSurveyEvent({
      actor: 'penilik',
      eventAction: 'view_gform',
      eventCategory: 'survey_kemudahan_pelaksanaan',
    })
    markAsSubmittedSurvey()
  }

  // -------------------------
  // Resolve visibility
  // -------------------------

  const isPelaksanaanSubmitted = useMemo(() => {
    const currentStateIndex =
      StatusPelaksanaanPraktikKinerjaList.indexOf(praktikKinerjaStatus)
    const submittedStateIndex = StatusPelaksanaanPraktikKinerjaList.indexOf(
      'REFLEKSI_TINDAK_LANJUT_PENILAIAN'
    )

    return currentStateIndex >= submittedStateIndex
  }, [praktikKinerjaStatus])

  const shouldShow =
    isSurveyEnabled && !isSurveySubmitted && isPelaksanaanSubmitted

  if (!shouldShow) {
    return null
  }

  return (
    <section
      className={clsx(
        'p-6 bg-white rounded-lg shadow-card space-y-4',
        className
      )}
    >
      <div className="flex gap-4 items-start">
        <img
          src={assetUrl('/illustrations/img-term-condition-TnC-list.png')}
          className="w-16 h-16 flex-shrink-0"
          alt=""
        />
        <Text variant="body-sm">
          Ada saran dan masukan untuk tahap <strong>Pelaksanaan</strong>?
          Ceritakan ke kami melalui survei.
        </Text>
      </div>

      <Button
        as="a"
        href="https://forms.gle/Y2oPxf39zTU41huz9"
        target="_blank"
        rel="noopener noreferrer"
        size="lg"
        color="white"
        fullWidth
        onClick={handleClickSurvey}
      >
        Isi Survei Pelaksanaan
      </Button>
    </section>
  )
}
